import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/store";

export interface MapState {
    fitGeom: any;
    highlightGeom: any;
    highlightGeomForTransportation: any;
    currentExtent: any;
    ol3D: any;
    highlightAll:any;
    mapZoom:any;
}

const initialState: MapState = {
    fitGeom: undefined,
    highlightGeom: undefined,
    highlightGeomForTransportation: undefined,
    currentExtent: undefined,
    ol3D: undefined,
    highlightAll:undefined,
    mapZoom:7
};

export const mapSlice = createSlice({
    name: 'mapState',
    initialState,
    reducers: {
        setFitGeom: (state: MapState, action) => {
            state.fitGeom = action.payload;
        },
        setHighlightGeom: (state: MapState, action) => {
            state.highlightGeom = action.payload;
        },
        setHighlightGeomForTransportation: (state: MapState, action) => {
            state.highlightGeomForTransportation = action.payload;
        },
        setHighlightAll: (state: MapState, action) => {
            state.highlightAll = action.payload;
        },
        setCurrentExtent: (state: MapState, action) => {
            state.currentExtent = action.payload;
        },
        setOl3D: (state: MapState, action) => {
            state.ol3D = action.payload;
        },
        setMapZoom: (state: MapState, action) => {
            state.mapZoom = action.payload;
        }
    }
})

export const { setFitGeom, setHighlightGeom,setHighlightAll, setHighlightGeomForTransportation, setCurrentExtent, setOl3D,setMapZoom } = mapSlice.actions;
export const selectFitGeom = (state: RootState) => state.mapState.fitGeom;
export default mapSlice.reducer;